import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { UserDetailContent } from './UserDetailContent';

// Required for static export with dynamic routes
// Returns empty array to indicate no pre-rendering (client-side routing only)
export async function generateStaticParams() {
    return [];
}

export default function UserDetailPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <UserDetailContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
